import { ProductsArrayPublicModels } from '@features/products/productsArray';

export function moveBannersToEndUseCase(
    categoryGrid: ProductsArrayPublicModels.PublicCategoryPlatformStudio,
    categoryId: string,
    bannersOrderConfig: Array<{ IdCategory: string[]; IdBanner: string }>
): ProductsArrayPublicModels.PublicCategoryPlatformStudio {
    // biome-ignore lint/complexity/useSimplifiedLogicExpression: <explanation>
    if (!categoryGrid || !bannersOrderConfig) {
        return categoryGrid;
    }

    const reorderedCategoryGrid = { ...categoryGrid };
    const categoryOrder = bannersOrderConfig.find(order => order.IdCategory.includes(categoryId));
    const bannerId = categoryOrder?.IdBanner ? Number(categoryOrder.IdBanner) : null;

    if (bannerId) {
        // Mover el idBanner al final de productIds si existe
        if (reorderedCategoryGrid.productIds.includes(bannerId)) {
            reorderedCategoryGrid.productIds = [
                ...reorderedCategoryGrid.productIds.filter(productId => productId !== bannerId),
                bannerId,
            ];
        }

        // Mover los elementos de grid que contengan el idBanner en ccIds al final
        if (reorderedCategoryGrid?.gridElements) {
            reorderedCategoryGrid.gridElements = [
                ...reorderedCategoryGrid.gridElements.filter(element => !element.ccIds.includes(bannerId)),
                ...reorderedCategoryGrid.gridElements
                    .filter(element => element.ccIds.includes(bannerId))
                    .map(element => ({
                        ...element,
                        ccIds: [...element.ccIds.filter(id => id !== bannerId), bannerId],
                    })),
            ];
        }
    }

    return reorderedCategoryGrid;
}
